module.exports = __webpack_public_path__ + "img/squared-burguer.0eebbdc9.jpg";